import {Link} from "react-router-dom";
import {CardShopRepository} from "../Repository/CardShopRepository";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import React from "react";


export class BasketComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cardShopCount: 0
        };
    }

    componentDidMount() {
        this.updateBasketCount();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.updateBasket !== this.props.updateBasket) {
            this.updateBasketCount();
        }
    }

    updateBasketCount = () => {
        const items = CardShopRepository.getAll();
        this.setState({
            cardShopCount: items ? items.length : 0
        });
    };

    render() {
        return (
            <Badge badgeContent={this.state.cardShopCount} color="secondary">
                <IconButton component={Link} to={"/cardShop"} color="inherit" size="small">
                    <AddShoppingCartIcon />
                </IconButton>
            </Badge>
        );
    }
}

